import { render, staticRenderFns } from "./AdministrativeEmpty.vue?vue&type=template&id=62257020&"
import script from "./AdministrativeEmpty.vue?vue&type=script&lang=js&"
export * from "./AdministrativeEmpty.vue?vue&type=script&lang=js&"
import style0 from "./AdministrativeEmpty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VFlex,VLayout,VSelect})
